import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { BookingsFromAvailabilityResponse, fetchBookingsFromAvailability } from "PFApp/booking/services/api";

import { bookingsFromAvailabilityKeys } from "./query_keys";

type UseBookingsFromAvailabilityProps = {
  activityId?: number;
  profileId?: number;
  options?: Omit<
    UseQueryOptions<BookingsFromAvailabilityResponse>,
    "queryKey" | "queryFn" | "initialData"
  > & {
    initialData?: () => undefined;
  };
};

export const useBookingsFromAvailability = ({
  activityId,
  profileId,
  options = {}
}: UseBookingsFromAvailabilityProps) =>
  useQuery<BookingsFromAvailabilityResponse>({
    queryKey: bookingsFromAvailabilityKeys.byActivityAndProfile(activityId, profileId),
    queryFn: () => fetchBookingsFromAvailability(activityId, profileId),
    retry: false,
    staleTime: 0,
    ...options
  });
